<template>
    <div class="login" v-if="loginShow" id="loginform">
        <el-form ref="loginForm" :model="loginForm" :rules="loginRules" class="login-form" v-show="!register">
          <i class="el-icon-circle-close close" @click="closeLogin"></i>
            <div class="login-title">
              <span class="logo-img"></span>
              <h1 class="logo-title" style="color: #000;">{{$t('login.signin') }}</h1>
            </div>
            <el-form-item prop="username">
                <el-input
                v-model="loginForm.username"
                type="text"
                auto-complete="off"
                :placeholder="this.$t('login.usernamoremail') "
                >
                <svg-icon slot="prefix" icon-class="user" class="el-input__icon input-icon" />
                </el-input>
            </el-form-item>
            <el-form-item prop="password">
                <el-input
                v-model="loginForm.password"
                type="password"
                auto-complete="off"
                :placeholder="this.$t('login.password') "
                show-password
                @keyup.enter.native="handleLogin"
                >
                <svg-icon slot="prefix" icon-class="password" class="el-input__icon input-icon" />
                </el-input>
            </el-form-item>
            <el-form-item prop="code" v-if="captchaEnabled">
                <el-input
                v-model="loginForm.code"
                auto-complete="off"
                :placeholder="this.$t('login.verificationCode')"
                style="width: 63%"
                @keyup.enter.native="handleLogin"
                >
                <svg-icon slot="prefix" icon-class="validCode" class="el-input__icon input-icon" />
                </el-input>
                <div class="login-code">
                <img :src="codeUrl" @click="getCode" class="login-code-img"/>
                </div>
            </el-form-item>
            <el-form-item style="width:100%;">
              
              <el-button
              :loading="loading"
              size="medium"
              type="primary"
                style="width:100%;"
                @click.native.prevent="handleLogin"
                >
                <span v-if="!loading">{{$t('login.loging')}}</span>
                <span v-else>{{$t('login.logIn')}}...</span>
                </el-button>
                <a class="register-btn" v-if="!loading" @click="register=true">{{ $t('login.register') }}</a>
                <div style="float: right;" v-if="register">
                </div>
              </el-form-item>
              <el-checkbox v-model="loginForm.rememberMe" style="margin:0px 0px 25px 0px;display: flex;">{{$t('login.remember') }} </el-checkbox>
            <span style="font-size: 14px;cursor: default;width: 100%;display: block;text-align: center;">{{$t('login.pleasecontact') }}:<a href="mailto:sales@kamsled.com" >sales@kamsled.com</a></span>
        </el-form>
        <el-form ref="registerForm" :model="registerForm" :rules="registerRules" class="register-form" v-show="register">
          <i class="el-icon-circle-close close" @click="closeLogin"></i>
            <div class="login-title">
              <span class="logo-img"></span>
              <h1 class="logo-title" style="color: #000;">{{ $t('login.register') }}</h1>
            </div>
            <el-form-item>
                  <el-col :span="10">
                      <el-form-item prop="firstname">
                        <el-input
                        v-model="registerForm.firstname"  
                        type="text"
                        auto-complete="off"
                        :placeholder="this.$t('login.firstname')"
                        >
                        <svg-icon slot="prefix" icon-class="user" class="el-input__icon input-icon" />
                      </el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                </el-col>
                <el-col :span="10">
                  <el-form-item prop="lastname">
                    <el-input
                    v-model="registerForm.lastname"  
                    type="text"
                    auto-complete="off"
                    :placeholder="this.$t('login.lastname')"
                  >
                </el-input>
              </el-form-item>
            </el-col>
          </el-form-item>
    
            <el-form-item>
              <el-col :span="10">
                <el-form-item prop="email">
                  <el-input
                    v-model="registerForm.email"  
                    type="text"
                    auto-complete="off"
                    :placeholder="this.$t('login.placeholder')"
                  >
                <svg-icon slot="prefix" icon-class="user" class="el-input__icon input-icon" />
              </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
            </el-col>
            <el-col :span="10" style="display: flex;">
              <el-form-item prop="phone">

                <el-select  :value="defaultNumber" @change="selectCountry" transfer="true" :popper-append-to-body="false">
                  <el-option
                  v-for="(country,index) in countryCode"
                  :key="index"
                  :label="country.zone"
                  :value="country">
                  <span style="float: left">{{'+'+ country.zone }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{ country.en }}</span>
                </el-option>
              </el-select>
              <el-input
                v-model="registerForm.phone" 
                type="text"
                auto-complete="off"
                :rules="[]"
                :placeholder="this.$t('login.phone')"
                ></el-input>
              </el-form-item>
              </el-col>
            </el-form-item>
            <el-form-item>
              <el-col :span="10">
                <el-form-item prop="password">
                    <el-input
                      v-model="registerForm.password"
                      type="password"
                      auto-complete="off"
                      :placeholder="this.$t('login.password')"
                      show-password
                      @keyup.enter.native="handleLogin"
                    >
                  <svg-icon slot="prefix" icon-class="password" class="el-input__icon input-icon" />
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="4"></el-col>
              <el-col :span="10">
                <el-form-item prop="passwordtwo">

                  <el-input
                  v-model="registerForm.passwordtwo"
                type="password"
                auto-complete="off"
                :placeholder="this.$t('login.retyoepassword')"
                show-password
                @keyup.enter.native="handleLogin"
                >
                <svg-icon slot="prefix" icon-class="password" class="el-input__icon input-icon" />
                </el-input>
              </el-form-item>
              </el-col>
            </el-form-item>
            <el-form-item prop="company">
              <el-input
                v-model="registerForm.company"
                type="text"
                auto-complete="off"
                :placeholder="this.$t('login.company')"
                @keyup.enter.native="handleLogin"
                >
                </el-input> 
            </el-form-item>
            <el-form-item>
              <el-col :span="10">
                <el-select :value="defaultCountry" @change="selectCountry" transfer="true" :popper-append-to-body="false" style="display:block;">
                <el-option
                  v-for="(country,index) in countryCode"
                  :key="index"
                  :label="country.en"
                  :value="country">
                </el-option>
              </el-select>
              </el-col>
              <el-col :span="4"></el-col>
              <el-col :span="10">
                <el-form-item prop="street">

                  <el-input
                  v-model="registerForm.street"
                  type="text"
                  auto-complete="off"
                :placeholder="this.$t('login.street')"
                @keyup.enter.native="handleLogin"
                >
                </el-input>
              </el-form-item>
              </el-col>
            </el-form-item>
            <el-form-item>
              <el-col :span="10">
                <el-form-item prop="city">
                  <el-input
                    v-model="registerForm.city"
                    type="text"
                    auto-complete="off"
                    :placeholder="this.$t('login.city')"
                    @keyup.enter.native="handleLogin"
                    >
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="4"></el-col>
              <el-col :span="10">
                <el-input
                v-model="registerForm.code"
                auto-complete="off"
                :placeholder="this.$t('login.verificationCode')"
                style="width: 67%"
                @keyup.enter.native="handleLogin"
                >
                <svg-icon slot="prefix" icon-class="validCode" class="el-input__icon input-icon" />
              </el-input>
              <div class="login-code">
                <img :src="codeUrl" @click="getCode" class="login-code-img"/>
              </div>
              </el-col>
             
            </el-form-item>
            <el-form-item prop="code" v-if="captchaEnabled">
              <el-col :span="4">
              </el-col>
              <el-col :span="10">
               
              </el-col>
            </el-form-item>
            <el-form-item style="width:100%;">
              
              <el-button
              :loading="loading"
              size="medium"
              type="primary"
                style="width:100%;"
                @click.native.prevent="handleRegister"
                >
                <span v-if="!loading">{{$t('login.register')}}</span>
                <span v-else>{{ $t('login.logIn') }}...</span>
                </el-button>
                <a class="register-btn" v-if="!loading" @click="register=false">{{ $t('login.signin') }}</a>
                <div style="float: right;" v-if="register">
                </div>
              </el-form-item>
        </el-form>
    </div>
    <div class="login" v-else-if="successTips&&!loginShow">
      <div class="register-bg-content">
        <div class="title">
          <span class="logo-img"></span>
          <H1>{{$t('login.registersuccess') }}</H1>
        </div>
        <p>{{ $t('login.registertips') }}</p>
        <button class="confirm" @click="confirm">{{ $t('enquiry.language_2') }}</button>
      </div>
    </div>
</template>
<script>
import { getCodeImg, register } from "@/api/user";
import Cookies from "js-cookie";
import { encrypt, decrypt } from '@/utils/jsencrypt'
import SvgIcon from '@/components/SvgIcon'
import countryCode from '@/utils/countryCode'
import { getUserIp } from "@/api/ip";
import store from '@/store'
import { emitEvent } from "@/utils/eventBus";
export default {
  name: "Login",
  components:{
    SvgIcon
  },
  data() {
    return {
      loginShow:true,
      successTips:false,
      codeUrl: "",
      countryCode:[],
      defaultNumber:'',
      defaultCountry:'',
      defaultRegx:'',
      registerForm:{
        firstname:'',
        lastname:'',
        email:'',
        phone:'',
        company:'',
        country:'',
        street:'',
        // zipcode:'',
        city:'',
        password:'',
        passwordtwo:'',
        code:'',
        uuid: "",
        ip:"",
      },
      loginForm: {
        username: "",
        password: "",
        rememberMe: false,
        code: "",
        uuid: ""
      },
      loginRules: {
        username: [
          { required: true, trigger: "blur", message: this.$t('login.usernametips') }
        ],
        password: [
          { required: true, trigger: "blur", message: this.$t('login.passwordtips') }
        ],
        code: [{ required: true, trigger: "change", message: this.$t('login.codetips') }]
      },
      registerRules:{
        firstname: [
          { required: true, trigger: "change", message: this.$t('login.firstnamtips') }
        ],
        lastname: [
          { required: true, trigger: "change", message: this.$t('login.lastnametips') }
        ],
        email: [{ required: true, trigger: "change", message: this.$t('login.emailtips') },
        { validator: this.RegExpEmaill, trigger: 'blur' }
        ],
        phone: [
          { required: true, trigger: "blur", message: this.$t('login.phonetips') },
          { validator: this.RegExpPhone, trigger: 'blur' }
        ],
        password: [{ required: true, trigger: "change", message: this.$t('login.passwordtips') },
        ],
        passwordtwo: [{ required: true, trigger: "change", message: this.$t('login.retyoepasswordtips') },
        { validator: this.RegExpPassword, trigger: 'blur' }
        ],
        company: [{ required: true, trigger: "change", message: this.$t('login.companytips') }],
        street: [{ required: true, trigger: "change", message: this.$t('login.streettips') }],
        // zipcode: [{ required: true, trigger: "change", message: "Please enter  your zipcode" }],
        city: [{ required: true, trigger: "change", message: this.$t('login.citytips') }],
      },
      loading: false,
      // 验证码开关
      captchaEnabled: true,
      // 注册开关
      register: false,
      redirect: undefined
    };
  },
  watch: {
    $route: {
      handler: function(route) {
        // 兼容在独立实例中未注入路由的情况
        if (route && route.query) {
          this.redirect = route.query.redirect
        } else {
          this.redirect = undefined
        }
      },
      immediate: true
    },
    registerForm: {
      handler: function(newVal, oldVal) {
        if (newVal.code) {
        }
      }
    }
  },
  created() {
    this.countryCode=countryCode;
    this.getCode();
    this.getCookie();
  },
  mounted(){
    this.initSelect();
  },
  methods: {
    async getIp(){
            await getUserIp().then(async (res)=>{
                if(res.code==200){
                  this.registerForm.ip=res.data.ip;
                   
                }else{
                  this.registerForm.ip="Fail to get";
                }
            })
        },
    confirm(){
      this.loginShow=true;
      this.successTips=false;
      this.closeLogin();
    },
    RegExpPassword(rule, value, callback){
      if(this.registerForm.password===this.registerForm.passwordtwo){
        callback();
      }
      else{
        callback(this.$t('login.passwordreg'))
      }
    },
    RegExpEmaill(rule, value, callback){
      if(new RegExp('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$').test(value)){
        callback();
      }
      else{
        callback(this.$t('login.emailreg'))
      }
    },
    RegExpPhone(rule, value, callback){
      if(this.defaultRegx.test(this.defaultNumber+value)){
        callback();
      }
      else{
        callback(this.$t('login.phonereg'))
      }
    },
    initSelect(){
      let i;
      if(countryCode[40])i=countryCode[40];
      this.defaultNumber='+'+i.zone;
      this.defaultCountry=i.en;
      this.defaultRegx=new RegExp(i.regex);
    },
    selectCountry(e){
      this.defaultRegx=new RegExp(e.regex);
      this.defaultNumber='+'+e.zone;
      this.defaultCountry=e.en;
    },  
    closeLogin(){
      this.loginShow=false;
      this.$emit('close');
    },
    openLogin(){
      this.loginShow=true; 
    },
    getCode() {
      getCodeImg().then(res => {
        this.captchaEnabled = res.captchaEnabled === undefined ? true : res.captchaEnabled;
        if (this.captchaEnabled) {
          this.codeUrl = "data:image/gif;base64," + res.img;
          this.loginForm.uuid = res.uuid;
          this.registerForm.uuid = res.uuid;
        }
      });
    },
    getCookie() {
      const username = Cookies.get("username");
      const password = Cookies.get("password");
      const rememberMe = Cookies.get('rememberMe')
      this.loginForm = {
        username: username === undefined ? this.loginForm.username : username,
        password: password === undefined ? this.loginForm.password : decrypt(password),
        rememberMe: rememberMe === undefined ? false : Boolean(rememberMe)
      };
    },
    handleLogin() {
      this.$refs.loginForm.validate( valid => {
        if (valid) {
          this.loading = true;
          if (this.loginForm.rememberMe) {
            Cookies.set("username", this.loginForm.username, { expires: 30 });
            Cookies.set("password", encrypt(this.loginForm.password), { expires: 30 });
            Cookies.set('rememberMe', this.loginForm.rememberMe, { expires: 30 });
          } else {
            Cookies.remove("username");
            Cookies.remove("password");
            Cookies.remove('rememberMe');
          }
           store.dispatch("user/Login", this.loginForm).then((res) => {
            // this.$router.push({ path: this.redirect || "/downloads" }).catch(()=>{});
            if(res.code==200){
              emitEvent('enquiry-message', {});
              this.loading = false;
              this.closeLogin();
              this.$message({
                message: this.$t('login.loginsuccess'),
                type: 'success',
                offset: 200,
                customClass: 'messageBox'
              });
             
            }
          }).catch((error) => {
            this.loading = false;
            if (this.captchaEnabled) {
              this.getCode();
            }
            if(error=="Error: 用户已封禁，请联系管理员"){
                this.$message({
                  message: this.$t('login.message1'),
                  type: 'error',
                  offset: 200,
                  customClass: 'messageBox'
              });
            }else if (error=="Error: 用户不存在/密码错误"){
                this.$message({
                  message: this.$t('login.message2'),
                  type: 'error',
                  offset: 200,
                  customClass: 'messageBox'
              });
            }else if (error=="Error: 验证码错误"){
              
                this.$message({
                  message: this.$t('login.message3'),
                  type: 'error',
                  offset: 200,
                  customClass: 'messageBox'
              });
            }else if (error=="Error: 验证码已失效"){
              
              this.$message({
                message: this.$t('login.message4'),
                type: 'error',
                offset: 200,
                customClass: 'messageBox'
            });
          }else{
            this.$message({
              message: error,
              type: 'error',
              offset: 200,
              customClass: 'messageBox'
          });
          }
          });
        }
      });
    },
    async handleRegister(){
      
             
      await this.getIp();
      this.$refs.registerForm.validate( async valid => {
        
        if (valid) {
          const loading = this.$loading({
                lock: true,
                text: 'Loading',
                // body:true,
                // spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.9)',
                target:document.querySelector("body")
                });
          this.registerForm.zonePhone=this.defaultNumber+this.registerForm.phone;
          this.registerForm.country=this.defaultCountry;
         await  store.dispatch("user/Register", this.registerForm).then((res) => {
            if(res.code==200){
              this.loading = false;
              this.loginShow=false;
              this.successTips=true;
                this.$message({
                  message: this.$t('login.registersuccess'),
                  type: 'success',
                  offset: 200,
                  customClass: 'messageBox'
                });

              }
              setTimeout(() => {
                    loading.close();
                    }, 500)
              
        }).catch((error) => {
            loading.close();
            if (this.captchaEnabled) {
              this.getCode();
            }
            if(error=="Error: 用户已封禁，请联系管理员"){
                this.$message({
                  message: this.$t('login.message5'),
                  type: 'error',
                  offset: 200,
                  customClass: 'messageBox'
              });
            }else if (error=="Error: The account must be between 2 and 40 characters long"){
                this.$message({
                  message: this.$t('login.message6'),
                  type: 'error',
                  offset: 200,
                  customClass: 'messageBox'
              });
            }else if (error=="Error: 验证码错误"){
                this.$message({
                  message: this.$t('login.message7'),
                  type: 'error',
                  offset: 200,
                  customClass: 'messageBox'
              });
            }else if (error=="Error: 失败，登录账号已存在"){
              this.$message({
                message: this.$t('login.message8'),
                type: 'error',
                offset: 200,
                customClass: 'messageBox'
            });
          }else if (error=="Error: 失败，手机号码已存在"){
              this.$message({
                message: this.$t('login.message9'),
                type: 'error',
                offset: 200,
                customClass: 'messageBox'
            });
          }else if (error=="Error: 失败，邮箱账号已存在"){
              
              this.$message({
                message: this.$t('login.message10'),
                type: 'error',
                offset: 200,
                customClass: 'messageBox'
            });
          }else if (error=="Error: Registration failed. The account already exists"){
              
              this.$message({
                message: this.$t('login.message10'),
                type: 'error',
                offset: 200,
                customClass: 'messageBox'
            });
          }else if (error=="Error: 验证码已失效"){
              
              this.$message({
                message: this.$t('login.message11'),
                type: 'error',
                offset: 200,
                customClass: 'messageBox'
            });
          }else{
            this.$message({
              message: error,
              type: 'error',
              offset: 200,
              customClass: 'messageBox'
          });
          }
          });
          
        }
      
      })
    }
  }
};
</script>
<style lang="less" scoped>
/deep/ .el-input input{
  border: none;          /* 清除所有边框 */
  border-bottom: 1px solid #000; /* 添加下边框 */
  outline: none;  
  border-radius:0;
}
/deep/ .el-input--prefix .el-input__inner {padding-left: 15px;}

.login {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  // background-image: url("../assets/images/login-background.png");
  background-size: cover;
  position: fixed;
  z-index: 1001 !important;
  top: 0%;
  left: calc(50% - 400px);
  &::before{
    display: block;
    content: '';
    width: 100vw;
    height: 100vh;
    position: fixed;
    z-index: 999 !important;
    top: 0;
    left: 0;
    background-color: rgba(0,0,0,0.5);
  }
  .register-bg-content{
    width: 800px;
    height: 600px;
    margin: 0 auto;
    background-color: white;
    z-index: 1001;
    display: flex;
    flex-direction: column;
    grid-gap: 100px;
    .title{
      width: 100%;
    display: flex;
    flex-direction: column;
    .logo-img{
      width: 100%;
      height: 75px;
      background-image: url("@/assets/image/kams-logo-black.svg");
      background-repeat: no-repeat;
      background-size: 40% ;
      background-position: -3rem;
    }
    h1{
      color: #000;
    }
    
  }
  p{
    width: 80%;
    margin: 0 auto;
    font-size: 18px;
    font-weight: bold;
    text-align: center;
  }
  .confirm{
      background-color: white;
      width: 100px;
      height: 40px;
      margin:  0 auto;
      border-radius: 4px;
      border-width: 1px;
      border-color: #ccc;
      cursor: pointer;
      font-weight: bold;
      &:hover{
        background: #D71518;
        color: white;
      }
    }
  }
  .close{

    position: absolute;
    top: 0;
    right: 0;
    z-index: 10000 !important;
    font-size: 36px;
    color: #000;
  }
}
.title {
  margin: 0px auto 30px auto;
  text-align: center;
  color: #707070;
}

.login-form {
  border-radius: 6px;
  background: #ffffff;
  width: 800px;
  z-index: 10000 !important;
  padding:40px 105px;
  box-sizing: border-box;
  position: relative;
  .login-title{
    width: 100%;
    display: flex;
    flex-direction: column;
    .logo-img{
      width: 100%;
      height: 30px;
      background-image: url("@/assets/image/kams-logo-black.svg");
      background-repeat: no-repeat;
      background-size: 40% ;
      background-position: -3rem;
    }
    .logo-title{
      flex: 1;
      display: flex;
      justify-content: center;
    }
  }
  .el-input {
    height: 38px;
    input {
      height: 38px;
    }
  }
  .input-icon {
    height: 39px;
    width: 14px;
    margin-left: 2px;
  }
  .register-btn{
    width: 100%;
    cursor: pointer;
    font-size: 14px;
    font-weight: bold;
    text-align: center;
    &:hover{
      text-decoration: underline;
      color: #D71518;
    }
  }
}
@media screen and (max-width: 1024px) {
  #loginform{
    left: 0;
    width: 100vw;
  }
  .login-form{
    margin: 0 auto;
    width: 80vw;
    padding: 40px;
    .login-title{
      .logo-img{
        background-size: 100%;
        background-position: -60px;
      }
      .logo-title{
        font-size: 20px;
      }
    }
  }
}
.login-tip {
  font-size: 13px;
  text-align: center;
  color: #bfbfbf;
}
.login-code {
  width: 33%;
  height: 38px;
  float: right;
  img {
    cursor: pointer;
    vertical-align: middle;
  }
}
.el-login-footer {
  
  height: 40px;
  line-height: 40px;
  position: fixed;
  bottom: 0;
  width: 100%;
  text-align: center;
  color: #fff;
  font-family: Arial;
  font-size: 12px;
  letter-spacing: 1px;
}
.login-code-img {
  height: 38px;
}
.register-form{
  border-radius: 6px;
  background: #ffffff;
  width: 800px;
  z-index: 10000 !important;
  padding:40px 45px;
  box-sizing: border-box;
  position: relative;
  .login-title{
    width: 100%;
    display: flex;
    flex-direction: column;
    .logo-img{
      width: 100%;
      height: 30px;
      background-image: url("@/assets/image/kams-logo-black.svg");
      background-repeat: no-repeat;
      background-size: 40% ;
      background-position: -3rem;
    }
    .logo-title{
      flex: 1;
      display: flex;
      justify-content: center;
    }
  }
  .el-input {
    height: 38px;
    input {
      height: 38px;
    }
  }
  .input-icon {
    height: 39px;
    width: 14px;
    margin-left: 2px;
  }
  .register-btn{
    width: 100%;
    cursor: pointer;
    font-size: 14px;
    font-weight: bold;
    text-align: center;
    &:hover{
      text-decoration: underline;
      color: #D71518;
    }
  }
}
/deep/ .el-form-item__content{
  display: flex;
}
/deep/ .el-checkbox__input{
  line-height: 1.5rem;
}
/deep/ .el-button--primary:hover{
  background: rgba(0,0,0,0.8);
  border-color: rgba(0,0,0,0.8);
}
/deep/ .el-button--primary{
  background: #000;
  border-color: #000;
}
/deep/ .el-checkbox__input.is-checked+.el-checkbox__label {
  color: #707070;
}
/deep/ .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
  background: rgba(0,0,0,0.8);
  border-color: rgba(0,0,0,0.8);
}
/deep/ .el-checkbox__inner:hover{
  border-color: #000;
}
/deep/ .el-select-dropdown__item.selected{
  color: #D71518;
}

</style>